module.exports = __webpack_public_path__ + "img/Wonder.adbeca51.png";